const moment = require("moment");
import { indicadorFacturacion } from "./comercial/facturacion";
import { db } from "../main";

const dateUtils = require("../utils/date-utils");

const facturacionInstance = new indicadorFacturacion();

function indicadoresController() {
  this.mapaIndicidadores = {
    facturacion: {
      name: "Facturación Total",
      id:"facturacion",
      unidad: "$",
      action: obtenerFacturacionTotal
    },
   /* ocupacion: {
      name: "Ocupación",
      id:"O",
      unidad: "%",
      action: nullfunc
    },
    mantenimiento: {
      name: "Mantenimiento",
      id:"M",
      unidad: "%",
      action: nullfunc
    },
    cobranza: {
      name: "Cobranza",
      unidad: "$",
      id:"C",
      action: nullfunc
    },
    */
    equipos: {
      name: "Equipos",
      id:"equipos",
      unidad: "U",
      action: obtenerEquipos
    }   
  };

  function obtenerIndicador(payload, workFunction) {}
  function nullfunc() {
    console.log("funciton nullfunc excecuted");
  }
  function obtenerEquipos(payload) {
    return new Promise((resolve, reject) => {
      var arrFechasReal = [];
      var arrFechasBase = [];

      const promises = new Array();
      const promisesBase = new Array();
      for (let i = 0; i < payload.periodos; i++) {
        const dates = dateUtils.getDates(
          payload.periodicidad,
          moment(payload.fecha)
            .add(i * -1, dateUtils.dateKeys[payload.periodicidad])
            .toDate()
        );
        const datesBase = dateUtils.getDates(
          payload.periodicidad,
          moment(payload.fecha)
            .add(i * -1, dateUtils.dateKeys[payload.periodicidad])
            .add(-1, "year")
            .toDate()
        );
        arrFechasReal.push(moment(dates.fechaIni).format("YYYY-MM-DD"));
        promises.push(
          db
            .ref("data")
            .child("ocupacion")
            .child(payload.sucursal)
            .orderByKey()
            .startAt(moment(dates.fechaIni).valueOf() + "")
            .endAt(moment(dates.fechaFin).valueOf() + "")
            .once("value")
        );
        arrFechasBase.push(moment(datesBase.fechaIni).format("YYYY-MM-DD"));
        promisesBase.push(
          db
            .ref("data")
            .child("ocupacion")
            .child(payload.sucursal)
            .orderByKey()
            .startAt(moment(datesBase.fechaIni).valueOf() + "")
            .endAt(moment(datesBase.fechaFin).valueOf() + "")
            .once("value")
        );
      }

      var objResult = { name: "Equipos", real: [], pb: [], meta: [], axis:1};
      Promise.all(promises).then(results => {
        results.forEach(result => {
          result.forEach(ocupacionFamiliaDiaSnapShot => {
            var totalOcupacion = {};
            var totalEquipos = 0;
            ocupacionFamiliaDiaSnapShot.forEach(equiposFamilia => {
              equiposFamilia.forEach(estado => {
                if (!totalOcupacion[estado.key]) totalOcupacion[estado.key] = 0;
                totalOcupacion[estado.key] += estado.val();
                totalEquipos += estado.val();
              });
            });
            objResult.real.push({
              name: arrFechasReal.pop(),
              y: totalEquipos, 
              indicador:"equipos"
            });
          });
          
          Promise.all(promisesBase).then(results => {
            results.forEach(result => {
              result.forEach(ocupacionFamiliaDiaSnapShot => {
                var totalOcupacion = {};
                var totalEquipos = 0;
                ocupacionFamiliaDiaSnapShot.forEach(equiposFamilia => {
                  equiposFamilia.forEach(estado => {
                    if (!totalOcupacion[estado.key]) totalOcupacion[estado.key] = 0;
                    totalOcupacion[estado.key] += estado.val();
                    totalEquipos += estado.val();
                  });
                });
                objResult.pb.push({
                  name: arrFechasBase.pop(),
                  y: totalEquipos
                });
              });
            });
            resolve(objResult);
          });
        });
      });
    });
  }

  function obtenerFacturacionTotal(payload) {
    return new Promise((resolve, reject) => {
      const promises = new Array();
      const promisesBase = new Array();
      facturacionInstance.getInvoicesData().then(() => {
        var arrFechasReal = [];
        var arrFechasBase = [];
        for (let i = 0; i < payload.periodos; i++) {
          const dates = dateUtils.getDates(
            payload.periodicidad,
            moment(payload.fecha)
              .add(i * -1, dateUtils.dateKeys[payload.periodicidad])
              .toDate()
          );
          const datesBase = dateUtils.getDates(
            payload.periodicidad,
            moment(payload.fecha)
              .add(i * -1, dateUtils.dateKeys[payload.periodicidad])
              .add(-1, "year")
              .toDate()
          );
          arrFechasReal.push(moment(dates.fechaIni).format("YYYY-MM-DD"));
          promises.push(
            facturacionInstance.calculateInvoicesDetailedAmmount(
              payload.sucursal,
              dates.fechaIni,
              dates.fechaFin
            )
          );
          arrFechasBase.push(moment(datesBase.fechaIni).format("YYYY-MM-DD"));
          promisesBase.push(
            facturacionInstance.calculateInvoicesDetailedAmmount(
              payload.sucursal,
              datesBase.fechaIni,
              datesBase.fechaFin
            )
          );
        }

        var objResult = {
          name: "Facturación Total",
          axis:0,
          id:"facturacion",
          real: [],
          pb: [],
          meta: []
        };
        Promise.all(promises).then(results => {
          results.forEach(result => {
            var totalInvoiced = 0;
            if (result.hashMapCountResult.open)
              totalInvoiced = result.hashMapCountResult.open;
            if (result.hashMapCountResult.paid)
              totalInvoiced = result.hashMapCountResult.paid;
            objResult.real.push({
              name: arrFechasReal.pop(),
              y: totalInvoiced, 
              indicador:"facturacion"
            });
          });
          Promise.all(promisesBase).then(results => {
            results.forEach(result => {
              var totalInvoiced = 0;
              if (result.hashMapCountResult.open)
                totalInvoiced = result.hashMapCountResult.open;
              if (result.hashMapCountResult.paid)
                totalInvoiced = result.hashMapCountResult.paid;
              objResult.pb.push({
                name: arrFechasBase.pop(),
                y: totalInvoiced
              });
            });
            resolve(objResult);
          });
        });
      });
    });
  }
}

export { indicadoresController };
